import familyTreeTranslations from '../../family-tree/config/translations.json';
import liquidityPlannerTranslations from '../../liquidity-planner/config/translations.json';
import type { IMap } from '../interfaces/generic';
import translations from './translations.json';

export const textResources: IMap<any> = { ...translations, ...familyTreeTranslations, ...liquidityPlannerTranslations };
